import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/logo/logo.svg'
import _imports_1 from '@/assets/icons/logo/appstore.png'


const _withScopeId = n => (_pushScopeId("data-v-a4a8c7b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hello" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "AI Trainer - Workout Tracker", -1))
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "appstore-logo"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slideshow = _resolveComponent("Slideshow")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createVNode(_component_Slideshow),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('main.slogan')), 1),
        _createElementVNode("a", {
          href: _ctx.getAppStoreLink,
          target: "_blank",
          rel: "noopener noreferrer"
        }, _hoisted_7, 8, _hoisted_5)
      ])
    ])
  ]))
}